export default __webpack_public_path__ + "static/media/Quick answers.eee1838d.svg";